import fieldFormPeriodoInsc from "./fieldFormPeriodoInsc";

const { startDate, endDay } = fieldFormPeriodoInsc;

const initialValuesPeriodo = (
  _startDate: Date | string = "",
  _endDay: Date | string = ""
) => {
  return {
    [startDate.name]: _startDate,
    [endDay.name]: _endDay,
  };
};

export default initialValuesPeriodo;
